module.exports = __webpack_public_path__ + "img/scratch.d3ed1931.png";